import React, { Component } from 'react';
import { format, formatISO, parseISO, set } from 'date-fns';
import { Container, Grid, Hidden, Typography, withStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { getPublicSite, getSitePublicImages, S3_URL } from '../../api';
import Preview from './Preview';
import HorizontalSelector from './Selector/Horizontal';
import FromDate from './FromDate';
import NPaper from '../NPaper';
import BaseMap from '../Map';
import { Skeleton } from '@material-ui/lab';


const styles = theme => ({
  root: {
    marginBottom: theme.spacing(2)
  },
  topNav: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  iconButton: {
    fontSize: 28,
    color: '#1a1a1a'
  },
  titleBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
});


const LIMIT = 20;

function TopNav(props) {
  const { business, classes } = props;

  return (
    <div className={classes.topNav}>
      {business?.logo
        ? <Link to='/'>
            <img
              src={`${S3_URL}/businesses/${business.id}/${business.logo}`}
              alt='Logo'
              height={30}
            />
          </Link>
        : <Skeleton variant='text' width={120} height={60} />} {/* Logo */}
    </div>
  );
}


/**
 * Public site page.
 * @param {} props
 */
class PublicSite extends Component {
  constructor(props) {
    super(props);

    this.originDate = new Date();

    this.state = {
      fromDate: this.originDate,
      site: null,
      business: null,
      images: [],
      selectedIdx: 0,
      loading: false,
      lastImage: false
    }
  }
  
  componentDidMount() {
    getPublicSite(this.props.match.params.siteId, {
      device: true
    })
      .then(({ business, ...site }) => {
        this.setState({ site, business });
        this.loadImages();
      })
      .catch(err => console.log(err));
  }


  useDate = (date) => {
    const endOfDay = set(date, {
      hours: 23,
      minutes: 59,
      seconds: 59,
      milliseconds: 999
    });

    if (endOfDay > this.originDate) return this.originDate;
    return endOfDay;
  }


  loadImages = (reset=false) => {
    const { site, loading, lastImage, fromDate, images } = this.state;
    if (loading || lastImage) return;
    this.setState({ loading: true });

    getSitePublicImages(site.id, {
      fromDate: formatISO(fromDate),
      offset: reset ? 0 : images.length,
      limit: LIMIT
    })
      .then(newImages => {
        this.setState({
          images: reset ? newImages : [...images, ...newImages ],
          loading: false,
          lastImage: newImages.length < LIMIT
        });
      })
      .catch(err => {
        console.log(err);
        this.setState({ loading: false});
      });
  }


  selectImage = (idx) => {
    this.setState({ selectedIdx: idx });
  }


  changeFromDate = (newDate) => {
    this.setState({
      fromDate: this.useDate(newDate),
      lastImage: false
    }, () => this.loadImages(true));
  }

  formatDate = isoStr => {
    if (!isoStr) return 'N/A';

    const dt = parseISO(isoStr);
    return format(dt, 'd/MM/y h:mm a');
  }

  render() {
    const { site, business, images, selectedIdx, fromDate } = this.state;
    const image = images[selectedIdx];
    const { classes } = this.props;

    if (!(site && business)) return null;

    // Set map location to the image location if supplied.
    var location;
    if (image && image.latitude && image.longitude) {
      location = {
        id: image.id,
        lat: image.latitude,
        lng: image.longitude
      };
    } else {
      location = {
        id: site.id,
        lat: site.device?.latitude,
        lng: site.device?.longitude
      };
    }

    // Render
    return (
      <Container maxWidth='lg' className={classes.root}>
        <TopNav
          business={business}
          classes={classes}
        />

        <div className={classes.titleBar}>
          <Typography variant='h5'>{site.name}</Typography>
        </div>


        <Grid container spacing={2}>
          <Grid item xs={12} md={8} lg={9}>
            <NPaper className={classes.gridPaper}>
              <Preview image={image} />
            </NPaper>
          </Grid>

          <Hidden mdUp>
            <Grid item xs={12}>
              <HorizontalSelector
                images={images}
                handleSelect={this.selectImage}
                scrollEnd={this.loadImages}
              />
            </Grid>
          </Hidden>


          <Grid
            item
            container
            spacing={2}
            xs={12}
            md={4}
            lg={3}
            style={{ textAlign: 'center' }}
          >
            {/* Captured At */}
            <Grid item xs={12} sm={6} md={12}>
              <NPaper padded fullHeight>
                {this.formatDate(image?.capturedAt)}
                <Typography variant='h6'>Captured At</Typography>
              </NPaper>
            </Grid>

            {/* From Date */}
            <Grid item xs={12} sm={6} md={12}>
              <NPaper padded fullHeight>
                <FromDate
                  fromDate={fromDate}
                  handleChange={this.changeFromDate}
                />
                <Typography variant='h6'>From Date</Typography>
              </NPaper>
            </Grid>
          </Grid>


          <Hidden smDown>
            <Grid item xs={12}>
              <HorizontalSelector
                images={images}
                handleSelect={this.selectImage}
                scrollEnd={this.loadImages}
              />
            </Grid>
          </Hidden>
        </Grid>


        <br/>

        {location && <>
          <Typography variant='body1'>Location</Typography>
          <NPaper>
            <BaseMap locations={[location]} />
          </NPaper>
        </>}
      </Container>
    );
  }
}


export default withStyles(styles)(PublicSite);
